// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__Xgy1g","header":"Header_header__kccgm"};